import {
    SET_ADDRESS_DETAILS
} from './AddressDetailsType';


const reducers = (state = {}, action: any) => {
    if (action.type === SET_ADDRESS_DETAILS) {
        const nextState: any = {
            ...state
        };

        if (action.target === 'thirdParty') {
            nextState.thirdPartyAddressDetails = action.addressDetails;
        }

        if (action.target === 'location') {
            nextState.locationAddressDetails = action.addressDetails;
        }

        if (!action.target) {
            nextState.addressDetails = action.addressDetails;
            nextState.thirdPartyAddressDetails = action.addressDetails;
            nextState.locationAddressDetails = action.addressDetails;
        }

        return nextState;
    }
    else {
        return state;
    }
}

export {
    reducers
}